module.exports = "/assets/fonts/ecda3c03.svg";